RivalIQ.apps.Admin.module('collections', function (collections, Admin, Backbone, Marionette, $, _) {

    'use strict';

    collections.Accounts = RivalIQ.collections.AtomicCollection.extend({
        model: Admin.models.Account,
        url: '/admin/api/accounts'
    });
});
